import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BottomNav from '../../components/feature/BottomNav';

const BusesPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [fromCity, setFromCity] = useState('');
  const [toCity, setToCity] = useState('');
  const [departureDate, setDepartureDate] = useState('');
  const [passengers, setPassengers] = useState(1);

  const popularRoutes = [
    {
      from: 'الرياض',
      to: 'جدة',
      duration: '10 ساعات',
      price: '120 ريال',
      image: 'https://public.readdy.ai/ai/img_res/824b6298d1cf03f3db9ad3d855043802.jpg'
    },
    {
      from: 'الدمام',
      to: 'الرياض',
      duration: '4 ساعات',
      price: '80 ريال',
      image: 'https://readdy.ai/api/search-image?query=Highway%20bus%20traveling%20on%20modern%20road%2C%20scenic%20landscape%2C%20professional%20travel%20photography%2C%20high%20quality%2C%20clear%20sky%2C%20centered%20composition&width=300&height=180&seq=9&orientation=landscape'
    },
    {
      from: 'جدة',
      to: 'مكة المكرمة',
      duration: '1.5 ساعة',
      price: '45 ريال',
      image: 'https://readdy.ai/api/search-image?query=Luxury%20coach%20bus%20exterior%2C%20modern%20design%2C%20professional%20automotive%20photography%2C%20high%20quality%2C%20isolated%20on%20white%20background%2C%20centered%20composition&width=300&height=180&seq=10&orientation=landscape'
    }
  ];

  const busCompanies = [
    {
      name: 'سابتكو',
      rating: 4.5,
      logo: 'https://readdy.ai/api/search-image?query=icon%2C%20Modern%20bus%20company%20logo%2C%20professional%20transportation%20branding%2C%20clean%20design%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20isolated%20on%20white%20background%2C%20centered%20composition&width=80&height=80&seq=11&orientation=squarish'
    },
    {
      name: 'النقل الجماعي',
      rating: 4.2,
      logo: 'https://readdy.ai/api/search-image?query=icon%2C%20Transportation%20company%20emblem%2C%20modern%20bus%20service%20logo%2C%20professional%20design%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20isolated%20on%20white%20background%2C%20centered%20composition&width=80&height=80&seq=12&orientation=squarish'
    },
    {
      name: 'الراجحي للنقل',
      rating: 4.7,
      logo: 'https://readdy.ai/api/search-image?query=icon%2C%20Premium%20bus%20service%20logo%2C%20luxury%20transportation%20branding%2C%20elegant%20design%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20isolated%20on%20white%20background%2C%20centered%20composition&width=80&height=80&seq=13&orientation=squarish'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* Header - محسن لحل مشكلة التداخل */}
      <div className="fixed top-0 left-0 right-0 bg-white shadow-sm z-40">
        <div className="flex items-center justify-between px-4 py-3 h-16">
          <button 
            onClick={() => navigate(-1)}
            className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0"
          >
            <i className="ri-arrow-right-line text-gray-600 text-lg"></i>
          </button>
          
          <div className="flex-1 text-center mx-4">
            <h1 className="text-lg font-bold text-gray-800 truncate">حجز الباصات</h1>
          </div>
          
          <button className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
            <i className="ri-more-line text-gray-600 text-lg"></i>
          </button>
        </div>
      </div>

      <div className="pt-20 px-4">
        {/* Search Form */}
        <div className="bg-white rounded-xl p-4 shadow-sm mb-6">
          <h2 className="text-lg font-bold text-gray-800 mb-4">ابحث عن رحلتك</h2>
          
          <div className="space-y-4">
            {/* From & To Cities */}
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">من</label>
                <div className="relative">
                  <input
                    type="text"
                    value={fromCity}
                    onChange={(e) => setFromCity(e.target.value)}
                    placeholder="المدينة"
                    className="w-full bg-gray-50 rounded-lg px-4 py-3 pr-10 text-sm border-none"
                  />
                  <i className="ri-map-pin-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">إلى</label>
                <div className="relative">
                  <input
                    type="text"
                    value={toCity}
                    onChange={(e) => setToCity(e.target.value)}
                    placeholder="المدينة"
                    className="w-full bg-gray-50 rounded-lg px-4 py-3 pr-10 text-sm border-none"
                  />
                  <i className="ri-map-pin-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                </div>
              </div>
            </div>

            {/* Date & Passengers */}
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">تاريخ السفر</label>
                <div className="relative">
                  <input
                    type="date"
                    value={departureDate}
                    onChange={(e) => setDepartureDate(e.target.value)}
                    className="w-full bg-gray-50 rounded-lg px-4 py-3 pr-10 text-sm border-none"
                  />
                  <i className="ri-calendar-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">عدد المسافرين</label>
                <div className="relative">
                  <select
                    value={passengers}
                    onChange={(e) => setPassengers(Number(e.target.value))}
                    className="w-full bg-gray-50 rounded-lg px-4 py-3 pr-10 text-sm border-none appearance-none"
                  >
                    {[1,2,3,4,5,6].map(num => (
                      <option key={num} value={num}>{num} مسافر</option>
                    ))}
                  </select>
                  <i className="ri-user-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                  <i className="ri-arrow-down-s-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
                </div>
              </div>
            </div>

            <button className="w-full bg-orange-600 text-white rounded-lg py-3 font-bold hover:bg-orange-700 transition-colors">
              البحث عن الباصات
            </button>
          </div>
        </div>

        {/* Popular Routes */}
        <div className="mb-6">
          <h2 className="text-lg font-bold text-gray-800 mb-4">الخطوط الشائعة</h2>
          <div className="space-y-3">
            {popularRoutes.map((route, index) => (
              <div key={index} className="bg-white rounded-xl p-4 shadow-sm">
                <div className="flex items-center space-x-4 space-x-reverse">
                  <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0">
                    <img
                      src={route.image}
                      alt={`${route.from} - ${route.to}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-1">
                      <h3 className="font-bold text-gray-800">{route.from} ← {route.to}</h3>
                      <span className="text-lg font-bold text-orange-600">{route.price}</span>
                    </div>
                    <p className="text-sm text-gray-600">مدة الرحلة: {route.duration}</p>
                  </div>
                  
                  <button className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-arrow-left-line text-orange-600"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bus Companies */}
        <div className="mb-6">
          <h2 className="text-lg font-bold text-gray-800 mb-4">شركات النقل</h2>
          <div className="grid grid-cols-3 gap-3">
            {busCompanies.map((company, index) => (
              <div key={index} className="bg-white rounded-xl p-4 shadow-sm text-center">
                <div className="w-12 h-12 mx-auto mb-2 rounded-lg overflow-hidden">
                  <img
                    src={company.logo}
                    alt={company.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <h3 className="font-bold text-gray-800 text-sm mb-1">{company.name}</h3>
                <div className="flex items-center justify-center space-x-1 space-x-reverse">
                  <i className="ri-star-fill text-yellow-400 text-xs"></i>
                  <span className="text-xs text-gray-600">{company.rating}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Features */}
        <div className="bg-white rounded-xl p-4 shadow-sm mb-6">
          <h2 className="text-lg font-bold text-gray-800 mb-4">مميزات الخدمة</h2>
          <div className="grid grid-cols-2 gap-4">
            <div className="flex items-center space-x-3 space-x-reverse">
              <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                <i className="ri-shield-check-line text-green-600"></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-800 text-sm">رحلات آمنة</h3>
                <p className="text-xs text-gray-600">سائقون محترفون</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-3 space-x-reverse">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                <i className="ri-wifi-line text-blue-600"></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-800 text-sm">واي فاي مجاني</h3>
                <p className="text-xs text-gray-600">إنترنت عالي السرعة</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-3 space-x-reverse">
              <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                <i className="ri-air-conditioner-line text-purple-600"></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-800 text-sm">تكييف مركزي</h3>
                <p className="text-xs text-gray-600">راحة طوال الرحلة</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-3 space-x-reverse">
              <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center">
                <i className="ri-24-hours-line text-orange-600"></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-800 text-sm">خدمة 24/7</h3>
                <p className="text-xs text-gray-600">دعم على مدار الساعة</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <BottomNav />
    </div>
  );
};

export default BusesPage;